import  DirectionsPartnersList from './DirectionsPartnersList';
export default DirectionsPartnersList
